import { useState, useEffect } from 'react';
import { useToast, EmptyState, inputStyle, pillBtn } from '../../teknav-ui.jsx';
import { adminApi } from '../lib/admin-api.js';
import { BRAND } from './Shared.jsx';

function SeriesManagementPanel() {
  const toast = useToast();
  const [items, setItems] = useState([]);
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const load = () => adminApi.listSeries().then(setItems).catch(() => setItems([]));
  useEffect(() => { load(); }, []);
  const create = async (e) => {
    e.preventDefault();
    await adminApi.createSeries({ title, description, articleIds: [] });
    setTitle('');
    setDescription('');
    toast('سری مقاله ایجاد شد');
    load();
  };
  return (
    <div style={{ display: 'grid', gap: 18, direction: 'rtl' }}>
      <form onSubmit={create} style={{ background: '#fff', border: '1px solid #E4DDD2', borderRadius: 12, padding: 16, display: 'grid', gap: 10 }}>
        <input value={title} onChange={e => setTitle(e.target.value)} placeholder="عنوان سری" style={inputStyle} dir="rtl" />
        <textarea value={description} onChange={e => setDescription(e.target.value)} placeholder="توضیح کوتاه" style={{ ...inputStyle, minHeight: 80 }} dir="rtl" />
        <button style={{ ...pillBtn, background: BRAND.primary, color: '#fff', justifySelf: 'start' }}>ایجاد سری</button>
      </form>
      {items.length === 0 ? <EmptyState title="هنوز سری مقاله‌ای در API نیست" /> : items.map(s => (
        <div key={s.id} style={{ background: '#fff', border: '1px solid #E4DDD2', borderRadius: 12, padding: 16 }}>
          <div style={{ fontWeight: 900, color: BRAND.ink }}>{s.title}</div>
          <div style={{ fontSize: 12, color: '#5F6B6D', marginTop: 4 }}>{(s.articles ?? []).length.toLocaleString('fa-IR')} مقاله · /series/{s.slug}</div>
        </div>
      ))}
    </div>
  );
}

export { SeriesManagementPanel };
